import React from "react";
import RootLayout from "../layouts/RootLayout";

import Programs from "../programs";
import Organizations from "../organizations";
import Promotions from "../promotions/index.jsx";
import ClosureMatrix from "../closure";
import QueuedRequests from "../queuedRequests";
import Reports from "../reports";
import RealTimeTest from "../realtimeTest";
import DownloadCodes from "../downloadCodes";
import PublicKey from "../publicKey";
import Validate from "../validate";
import Dashboard from "../pages/Dashboard";
import Release from "../release";
import CrediColaReport from "../credicola";

const routes = [{
  path: '/', element: <RootLayout />,
  children: [
    { path: '/programs', element: <Programs /> },
    { path: '/release', element: <Release /> },
    { path: '/organizations', element: <Organizations /> },
    { path: '/promotions', element: <Promotions /> },
    { path: "/closure", element: <ClosureMatrix /> },
    { path: '/queued-requests', element: <QueuedRequests /> },
    { path: '/reports', element: <Reports /> },
    { path: '/real-time-test', element: <RealTimeTest /> },
    { path: '/download-codes', element: <DownloadCodes /> },
    { path: '/public-key', element: <PublicKey /> },
    { path: '/validate', element: <Validate /> },
    { path: '/', element: <Dashboard /> },
    { path: '/credicola', element: <CrediColaReport /> },
  ],
}];

export default routes;
